<template>
  <div class="iconos-radios">
    <icono-seleccionable
      v-for="(icono, index) in iconos"
      :key="index"
      v-model="localValue"
      :icon="icono.icon"
      :checked-value="icono.value"
      :icon-type="icono.iconType"
      :active-class="icono.activeClass"
      :data-toggle="icono.tooltip ? 'tooltip' : undefined"
      :title="icono.tooltip"
    />
  </div>
</template>

<script>
/*
Lista de iconos que se puede seleccionar únicamente uno de ellos.
la configuración será:

iconos: [
  { icon: 'star', value: 'todo', activeClass: 'text-danger', tooltip: 'Todo' },
  { icon: 'circle', iconType: 'fas', value: 'nada' },
]
*/
import IconoSeleccionable from './IconoSeleccionable.vue';

export default {
  components: { IconoSeleccionable },
  props: {
    modelValue: { type: String, required: false, default: null },
    iconos: { type: Array, required: true },
  },
  data() {
    return {
      localValue: this.modelValue,
    };
  },
  watch: {
    modelValue() {
      this.localValue = this.modelValue;
    },
    localValue() {
      this.$emit('update:modelValue', this.localValue);
    },
  },
  methods: {

  },
};
</script>
